import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAllActivityBasedContent } from 'redux/user/user.selectors';
import PromoCode from '../promo-code.component';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import CheckoutPromoCode from '../checkout-promo-code/checkout-promo-code.component';

const MenuPromoCode = ({ open, handleClose }) => {
  const messages = useSelector(selectAllActivityBasedContent);
  const { t } = useTranslation();
  const isCheckout = useRouteMatch(['/checkout']);

  const validateResponse = useCallback(
    result => {
      if (
        !result?.offerList?.offers?.length &&
        !result?.messageList?.messages?.length
      ) {
        return `${t('payment.promoCode.emptyContent1')} ${t(
          'payment.promoCode.emptyContent2',
        )}`;
      }
    },
    [t],
  );

  if (isCheckout)
    return <CheckoutPromoCode open={open} handleClose={handleClose} />;

  return (
    <PromoCode
      open={open}
      handleClose={handleClose}
      validateResponse={validateResponse}
      messages={messages}
    />
  );
};
export default MenuPromoCode;
